export var Roles;

(function (Roles) {
  Roles["GRAPHICS_DOCUMENT"] = "graphics-document";
  Roles["GRAPHICS_OBJECT"] = "graphics-object";
  Roles["GRAPHICS_SYMBOL"] = "graphics-symbol";
  Roles["GROUP"] = "group";
})(Roles || (Roles = {}));